import axios from "axios";

export default axios.create({
  baseURL: `https://api.yanilyexpertisefinanciere.com/`,
  headers: {
    'Content-Type': 'application/json',
  },
//baseURL: `http://localhost/api.yanilicompta/`,`,
});